import { BoardUserActivityType } from '@/api/workspaceSettings/queries';
import { uuid } from '@/_core/utils/uuid';

import * as storymapStoreModule from '../../../store';
import { MoveCardToActivity, MoveCardToTask, MoveCardToSubtask } from '../../../store';
import { MoveCard, CardType } from '..';
import { getCardById, isActivity, isSubtask, isTask } from '../../../store/use';

export const createMoveCardToSubTaskCommand = async (action: MoveCardToSubtask) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const card = getCardById(action.id);

    const destionationTask = state.tasks.find((x) => x.id === action.taskId);
    const destinationType = action.releaseId ? CardType.Subtask : CardType.UnscheduledSubtask;
    const destinationRelease = state.releases.find((x) => x.id === action.releaseId);
    const sourceRelease = isSubtask(card) && card.releaseId ? state.releases.find((x) => x.id === card.releaseId) : null;
    const sourceReleaseName = sourceRelease && sourceRelease.id !== action.releaseId ? sourceRelease.name : null;

    let cmd: MoveCard;
    if (isSubtask(card)) {
        const sourceType = card.releaseId ? CardType.Subtask : CardType.UnscheduledSubtask;

        cmd = new MoveCard(
            state.id,
            card.id,
            sourceType,
            card.activityId,
            card.taskId,
            card.releaseId,
            card.order,
            destinationType,
            destionationTask.activityId,
            destionationTask.id,
            action.releaseId,
            action.newOrder
        );
    }

    if (isTask(card)) {
        cmd = new MoveCard(
            state.id,
            card.id,
            CardType.Task,
            card.activityId,
            null,
            null,
            card.order,
            destinationType,
            destionationTask.activityId,
            destionationTask.id,
            action.releaseId,
            action.newOrder
        );
    }

    if (isActivity(card)) {
        cmd = new MoveCard(
            state.id,
            card.id,
            CardType.Activity,
            null,
            null,
            null,
            card.order,
            destinationType,
            destionationTask.activityId,
            destionationTask.id,
            action.releaseId,
            action.newOrder
        );
    }

    const boradActivityId = await uuid.create();

    const activity = {
        Id: boradActivityId,
        CardId: card.id,
        CardName: card.title,
        Datetime: new Date().toJSON(),
        ParentCardId: destionationTask.id,
        ParentCardName: destionationTask.title,
        Position: action.newOrder,
        ReleaseId: action.releaseId,
        ReleaseName: action.releaseId == null ? null : destinationRelease.name,
        OriginalContent: sourceReleaseName,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: action.releaseId == null ? BoardUserActivityType.MovedIntoUnscheduledSubtasks : BoardUserActivityType.MovedIntoSubtasks,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    cmd.BoardActivity = activity;

    return cmd;
};

export const createMoveCardToActivityCommand = async (action: MoveCardToActivity) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const card = getCardById(action.id);

    let cmd: MoveCard;
    if (isSubtask(card)) {
        const sourceType = card.releaseId ? CardType.Subtask : CardType.UnscheduledSubtask;

        cmd = new MoveCard(
            state.id,
            card.id,
            sourceType,
            card.activityId,
            card.taskId,
            card.releaseId,
            card.order,
            CardType.Activity,
            null,
            null,
            null,
            action.newOrder
        );
    }

    if (isTask(card)) {
        cmd = new MoveCard(
            state.id,
            card.id,
            CardType.Task,
            card.activityId,
            null,
            null,
            card.order,
            CardType.Activity,
            null,
            null,
            null,
            action.newOrder
        );
    }

    if (isActivity(card)) {
        cmd = new MoveCard(
            state.id,
            card.id,
            CardType.Activity,
            null,
            null,
            null,
            card.order,
            CardType.Activity,
            null,
            null,
            null,
            action.newOrder
        );
    }

    const boradActivityId = await uuid.create();

    const activity = {
        Id: boradActivityId,
        CardId: card.id,
        CardName: card.title,
        Datetime: new Date().toJSON(),
        ParentCardId: null as any,
        ParentCardName: null as any,
        Position: action.newOrder,
        ReleaseId: null as any,
        ReleaseName: null as any,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.MovedIntoActivities,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    cmd.BoardActivity = activity;

    return cmd;
};

export const createMoveCardToTaskCommand = async (action: MoveCardToTask) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const card = getCardById(action.id);

    const destionationActivity = state.activities.find((x) => x.id === action.activityId);

    let cmd: MoveCard;
    if (isSubtask(card)) {
        const sourceType = card.releaseId ? CardType.Subtask : CardType.UnscheduledSubtask;

        cmd = new MoveCard(
            state.id,
            card.id,
            sourceType,
            card.activityId,
            card.taskId,
            card.releaseId,
            card.order,
            CardType.Task,
            destionationActivity.id,
            null,
            null,
            action.newOrder
        );
    }

    if (isTask(card)) {
        cmd = new MoveCard(
            state.id,
            card.id,
            CardType.Task,
            card.activityId,
            null,
            null,
            card.order,
            CardType.Task,
            destionationActivity.id,
            null,
            null,
            action.newOrder
        );
    }

    if (isActivity(card)) {
        cmd = new MoveCard(
            state.id,
            card.id,
            CardType.Activity,
            null,
            null,
            null,
            card.order,
            CardType.Task,
            destionationActivity.id,
            null,
            null,
            action.newOrder
        );
    }

    const boradActivityId = await uuid.create();

    const activity = {
        Id: boradActivityId,
        CardId: card.id,
        CardName: card.title,
        Datetime: new Date().toJSON(),
        ParentCardId: destionationActivity.id,
        ParentCardName: destionationActivity.title,
        Position: action.newOrder,
        ReleaseId: null as any,
        ReleaseName: null as any,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.MovedIntoTasks,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    cmd.BoardActivity = activity;

    return cmd;
};
